import { render, staticRenderFns } from "./openSkus.vue?vue&type=template&id=4bf8ab34&scoped=true"
import script from "./openSkus.vue?vue&type=script&lang=js"
export * from "./openSkus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf8ab34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bf8ab34')) {
      api.createRecord('4bf8ab34', component.options)
    } else {
      api.reload('4bf8ab34', component.options)
    }
    module.hot.accept("./openSkus.vue?vue&type=template&id=4bf8ab34&scoped=true", function () {
      api.rerender('4bf8ab34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aftersale/openSkus.vue"
export default component.exports